import { STORAGE_KEY } from '../constants/generic';
import { getAppObj } from './utils';

export function parseAuthTokensFromApi(headers) {
  let { 'x-auth-token': token, 'x-refresh-token': refreshToken } = headers || {};

  if (token === 'null') token = undefined;
  if (refreshToken === 'null') refreshToken = undefined;
  return { token, refreshToken };
}

export function clearAuthTokens() {
  delete getAppObj()[STORAGE_KEY.AUTH_TOKEN];
  localStorage.removeItem(STORAGE_KEY.AUTH_TOKEN);
  delete getAppObj()[STORAGE_KEY.AUTH_REFRESH_TOKEN];
  localStorage.removeItem(STORAGE_KEY.AUTH_REFRESH_TOKEN);
}

export function clearSsoTokens() {
  delete getAppObj()[STORAGE_KEY.SSO_TOKEN];
  localStorage.removeItem(STORAGE_KEY.SSO_TOKEN);
  delete getAppObj()[STORAGE_KEY.SSO_REFRESH_TOKEN];
  localStorage.removeItem(STORAGE_KEY.SSO_REFRESH_TOKEN);
}

export function saveSsoTokens({ token, refreshToken } = getAppObj().keycloak || {}) {
  // Tokens are kept in memory only (never persisted to web storage) to limit XSS exposure.
  if (token) getAppObj()[STORAGE_KEY.SSO_TOKEN] = token;
  if (refreshToken) getAppObj()[STORAGE_KEY.SSO_REFRESH_TOKEN] = refreshToken;
  clearAuthTokens();
}

export function saveAuthTokens({ token, refreshToken }) {
  // Tokens are kept in memory only (never persisted to web storage) to limit XSS exposure.
  if (token) getAppObj()[STORAGE_KEY.AUTH_TOKEN] = token;
  if (refreshToken) getAppObj()[STORAGE_KEY.AUTH_REFRESH_TOKEN] = refreshToken;
  clearSsoTokens();
}

// Tokens are no longer persisted to web storage. These functions remain to purge any
// tokens left in localStorage by previous app versions (security hardening / migration).
export function restoreAuthTokens() {
  localStorage.removeItem(STORAGE_KEY.AUTH_TOKEN);
  localStorage.removeItem(STORAGE_KEY.AUTH_REFRESH_TOKEN);
}

export function restoreSsoTokens() {
  localStorage.removeItem(STORAGE_KEY.SSO_TOKEN);
  localStorage.removeItem(STORAGE_KEY.SSO_REFRESH_TOKEN);
}

export function getAppAuthTokens() {
  return {
    token: getAppObj()[STORAGE_KEY.AUTH_TOKEN],
    refreshToken: getAppObj()[STORAGE_KEY.AUTH_REFRESH_TOKEN]
  };
}

export function getAppSsoTokens() {
  return {
    token: getAppObj()[STORAGE_KEY.SSO_TOKEN],
    refreshToken: getAppObj()[STORAGE_KEY.SSO_REFRESH_TOKEN]
  };
}

export function noTokensFound() {
  const tokens = getAppAuthTokens();
  const ssoTokens = getAppSsoTokens();

  return !(
    tokens.token ||
    tokens.refreshToken ||
    ssoTokens.token ||
    ssoTokens.refreshToken
  );
}
